import { Button } from "@hoylu/client-common";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectDashboardSelectedProject } from "../state/workspaces/projects.selector";
import { loadWorkspaces } from "../state/workspaces/workspaces.actions";
import {
  selectWorkspaces,
  selectWorkspacesPagination,
} from "../state/workspaces/workspaces.selector";
import { useI18n } from "../utils/hooks/use.i18n";
import Styles from "./LoadMoreWorkspacesButton.module.css";

export const LoadMoreWorkspacesButton: React.FC = () => {
  const dispatch = useDispatch();

  const t = useI18n("LOAD_MORE_WORKSPACES.");

  const selectedProject = useSelector(selectDashboardSelectedProject);
  const workspaces = useSelector(selectWorkspaces);
  const { data } = useSelector(selectWorkspacesPagination);

  const showLoadMoreButton = useMemo(() => {
    const canFetchMore = !!workspaces.length && !!data?.offset;

    return !selectedProject && canFetchMore;
  }, [data, selectedProject, workspaces]);

  const loadMoreHandler = () => {
    dispatch(
      loadWorkspaces.request({
        offset: data?.offset || undefined,
      }),
    );
  };

  return (
    <React.Fragment>
      {showLoadMoreButton && (
        <div className={Styles.loadMoreWorkspaces}>
          <Button onClick={loadMoreHandler} type="primary">
            {t("LOAD_MORE")}
          </Button>
        </div>
      )}
    </React.Fragment>
  );
};
